import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import * as batshit from '@yornaath/batshit';


export type CollaborativeChartReviewsConfig = {
  stateId: string;
  frequency: 'weekly' | 'monthly' | 'quarterly' | 'annually';
  sampleChartsAmountPercentage: number;
  minimumChartsAmount: number;
  maximumChartsAmount: number;
};


export const getCollaborativeChartReviewConfigsByIds = async (stateIds?: string[]) => restClient.request<{ data: CollaborativeChartReviewsConfig[] }>('/api/v1/collaborative_chart_reviews_config', {
  method: 'POST',
  data: {
    ids: stateIds,
  }
});


const collaborativeChartReviewsConfigBatch = batshit.create({
  fetcher: async (stateIds: string[]) => {
    const response = await getCollaborativeChartReviewConfigsByIds(stateIds.filter(Boolean));

    return response.data;
  },
  resolver: (response, key) => response?.find((item) => item.stateId === key) ?? null,
  scheduler: batshit.windowScheduler(10)
});

export const getCollaborativeChartReviewsConfigById = async (stateId: string) => collaborativeChartReviewsConfigBatch.fetch(stateId);


export type UpdateCollaborativeChartReviewsConfigParams = CollaborativeChartReviewsConfig;
export const updateCollaborativeChartReviewsConfig = async (params: UpdateCollaborativeChartReviewsConfigParams) => restClient.request<null>(`/api/v1/collaborative_chart_reviews_config/${params.stateId}`, {
  method: 'PUT',
  data: snakecaseKeys(params)
});

export const deleteCollaborativeChartReviewsConfig = async (stateId: string) => restClient.request<null>(`/api/v1/collaborative_chart_reviews_config/${stateId}`, {
  method: 'DELETE',
});
